import { socials } from '@/config/socialDistribution'
import { ModelId } from './api'
import { Image, ImageTransform } from './image'
import { Video } from './widget/video'

export enum SocialDistributionStatus {
  NEW = 'new',
  PUBLISHED = 'published',
  PUBLISHING = 'publishing',
  ERROR = 'error',
  PLANNED = 'planned',
}

export type SocialCode = keyof typeof socials

export interface SocialDistribution {
  id: number
  cid: number
  model_id: ModelId
  item_id: number
  status: SocialDistributionStatus
  net_name: SocialCode
  channel: string
  channel_name?: string
  active_from: string | null
  republish_from: string | null
  text: string | null
  link?: string | null
  image_id: number | null
  image?: ImageTransform | null
  enabled: boolean
  images: Image[]
  gallery_id: null | number
  video_id: null | number
  gallery: SocialGallery | null
  video: Video | null
  published_now?: boolean
  published?: boolean
  error_description?: string
}

export interface SocialGroup {
  code: string
  name: string
}

export interface SocialsSetting {
  max_symbol: number
  multiple_photos: boolean
  gallery: boolean
  video: boolean
  editorToolbar: string[][]
}

export interface SocialGallery {
  id: number
  create_date: string
  name: string
}
